
import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faBars, faCaretUp, faCaretDown, faTimes} from '@fortawesome/free-solid-svg-icons'

function FrontHeader() {
  const [sidebar, setSidebar] = useState(false);
  const [coins, setCoins] = useState([]);
  const [news, setNews] = useState([]);
  useEffect(() => {
    fetch(`/coin_list.txt`)
    .then((res) => res.json())
    .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          percentage: Number(coin.quote.USD.percent_change_24h.toFixed(2))
      }));
      setCoins(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/apixxx_market.txt`)
    .then((res) => res.json())
    .then((data) => {
      var newsList = data.articles.results;
      const updatedData = newsList.map((newss, index) => ({
        id: index + 1,
        image: newss.image,
        title: newss.title,
        source: newss.source.title,
        date: newss.date,
      }));
      console.log(updatedData)
      setNews(updatedData);
    })
    .catch((err) => console.error("Error loading news list:", err));
  }, []);
  return (
    <>
      <div className={`rounded-5 p-4 sidenav ${sidebar?'active':null}`}>
        <nav className='flex-column d-flex justify-content-center h-100'>
          <Link to="/" className='active'>Home</Link>
          <Link to="/about">About us</Link>
          <Link to="/faq">Faq</Link>
          <Link to="/terms">Terms and conditions</Link>
          <Link to="/whyus">Why Us</Link>
          <Link to="/account" state={{location: 'login'}}>Login</Link>
          <Link to="/account" state={{location: 'register'}}>Register</Link>
        </nav>
      </div>
      <header className="header py-1" style={{position:'relative', zIndex: 6, backgroundColor:'rgb(91 91 91)'}}>
        <div className='d-flex align-items-center'>
          <Link to="/" className='active'><img src="/mainlogo.png" alt="Company Logo" style={{height: '40px'}} /></Link>
          <nav className='ms-4'>
            <a href='/' className='active hasdrop'>Cryptocurrencies
              <div className='customdropdown'>
                <a href='/' className='hassubdrop'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <span>Rankings</span>
                    <div className='d-flex align-items-center'>
                      <span className='px-1 rounded-1 bg-info fw-semibold text-white' style={{fontSize: '10px'}}>Top</span>
                      <FontAwesomeIcon icon={faAngleRight} className='ms-1' style={{fontSize:'14px'}}  />
                    </div>
                  </div>
                  <div className='subcustomdropdown'>
                    {coins.slice(0, 7).map((coin) => (
                      <div key={coin.id} className='rounded-4 border d-flex align-items-end justify-content-between p-2 mb-1'>
                        <div className='d-flex align-items-center'>
                          <img src={coin.logo} alt={coin.name} style={{width: '25px'}} />
                          <div className='ms-2'>
                            <h6 className='mb-0 fw-bold'>{coin.name}</h6>
                            <p className='fw-semibold mb-0'>${coin.price}</p>
                          </div>
                        </div>
                        <p className={`mb-0 ${coin.percentage > 0 ? 'text-success' : 'text-danger'} fw-bold`} style={{fontSize: '14px'}}><FontAwesomeIcon icon={coin.percentage > 0 ? faCaretUp : faCaretDown} className='me-1' /> {coin.percentage}%</p>
                      </div>
                    ))}
                  </div>
                </a>
                <a href='/' className='hassubdrop'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <span>Crypto Prices</span>
                    <FontAwesomeIcon icon={faAngleRight} className='ms-1' style={{fontSize:'14px'}}  />
                  </div>
                  <div className='subcustomdropdown'>
                    {coins.slice(0, 50).map((coin) => (
                      <div key={coin.id} className='rounded-4 border d-flex align-items-end justify-content-between p-2 mb-1'>
                        <div className='d-flex align-items-center'>
                          <img src={coin.logo} alt={coin.name} style={{width: '25px'}} />
                          <div className='ms-2'>
                            <h6 className='mb-0 fw-bold'>{coin.name}</h6>
                            <p className='fw-semibold mb-0'>${coin.price}</p>
                          </div>
                        </div>
                        <p className={`mb-0 ${coin.percentage > 0 ? 'text-success' : 'text-danger'} fw-bold`} style={{fontSize: '14px'}}><FontAwesomeIcon icon={coin.percentage > 0 ? faCaretUp : faCaretDown} className='me-1' /> {coin.percentage}%</p>
                      </div>
                    ))}
                  </div>
                </a>
                <a href='/'>Top Gainers & Losers</a>
                <a href='/'>Crypto Market Overview</a>
                <a href='/'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <span>Fear And Greed Index </span>
                    <span className='px-1 rounded-1 bg-danger fw-semibold text-white' style={{fontSize: '10px'}}>Trending</span>
                  </div>
                </a>
                <a href='/' className='hassubdrop'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <span>Buy Cryptocurrency</span>
                    <FontAwesomeIcon icon={faAngleRight} className='ms-1' style={{fontSize:'14px'}}  />
                  </div>
                  <div className='subcustomdropdown' style={{minWidth: '500px'}}>
                    <div className='row'>
                      {coins.slice(0, 6).map((coin, index) => (
                      <div className='col-6' key={index}>
                        <div className='rounded-4 border d-flex align-items-end justify-content-between py-2 mb-2'>
                          <div className='d-flex align-items-center flex-column w-100'>
                            <img src={coin.logo} alt={coin.name} style={{width: '30px'}} />
                            <h6 className='mb-0 fw-bold mt-0' style={{fontSize: '14px'}}>{coin.name} ({coin.symbol})</h6>
                            <div className='d-flex align-items-center mb-0'>
                              <p className='fw-semibold mb-0' style={{fontSize: '18px'}}>${coin.price}</p>
                              <p className={`mb-0 ${coin.percentage > 0 ? 'text-success' : 'text-danger'} fw-bold`} style={{fontSize: '14px'}}><FontAwesomeIcon icon={coin.percentage > 0 ? faCaretUp : faCaretDown} className='ms-3' /> {coin.percentage}%</p>
                            </div>
                            <a href='/' className='px-2 py-1 rounded-3 bg-success text-white fw-semibold'>Buy {coin.symbol}</a>
                          </div>
                        </div>
                      </div>
                      ))}
                    </div>
                  </div>
                </a>
                <a href='/' className='hassubdrop'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <span>News</span>
                    <FontAwesomeIcon icon={faAngleRight} className='ms-1' style={{fontSize:'14px'}}  />
                  </div>
                  <div className='subcustomdropdown' style={{minWidth: '330px'}}>
                    {news.slice(0, 5).reverse().map((newItem) => (
                    <div key={newItem.id} className='rounded-4 border d-flex p-2 mb-2'>
                      <div className='rounded-3 d-flex align-items-center justify-content-center overflow-hidden' style={{width: '110px', height: '70px', minWidth: '110px', minHeight: '70px'}}>
                        <img src={newItem.image || 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'}alt={newItem.title}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'; // Fallback image
                        }} style={{width: '100%', height: '100%',objectFit: 'cover'}} />
                      </div>
                      <div className='flex-1 ms-2'>
                        <h6 className="mb-0 fw-semibold" style={{ fontSize: '14px' }}>
                          {newItem.title.split(' ').length <= 10
                            ? newItem.title
                            : `${newItem.title.split(' ').slice(0, 10).join(' ')}...`}
                        </h6>
                        <span className='mb-0' style={{fontSize: '10px', color: 'gray'}}>{newItem.date}</span>
                      </div>
                    </div>
                    ))}
                  </div>
                </a>
              </div>
            </a>
            <a href='/' className='hasdrop'>Exchanges
              <div className='customdropdown'>
                <a href='/'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <span>Spot</span>
                  </div>
                </a>
                <a href='/'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <span>DEX</span>
                  </div>
                </a>
                <a href='/'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <span>Top Exchanges</span>
                    <span className='px-1 rounded-1 bg-danger fw-semibold text-white' style={{fontSize: '10px'}}>Hot</span>
                  </div>
                </a>
                <a href='/' className='hassubdrop'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <span>News</span>
                    <FontAwesomeIcon icon={faAngleRight} className='ms-1' style={{fontSize:'14px'}} />
                  </div>
                  <div className='subcustomdropdown' style={{minWidth: '330px'}}>
                    {news.slice(0, 5).reverse().map((newItem) => (
                    <div key={newItem.id} className='rounded-4 border d-flex p-2 mb-2'>
                      <div className='rounded-3 d-flex align-items-center justify-content-center overflow-hidden' style={{width: '110px', height: '70px', minWidth: '110px', minHeight: '70px'}}>
                        <img src={newItem.image || 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'}alt={newItem.title}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://res.cloudinary.com/coinpaper/image/upload/v1680001325/arb_fba92b25bc.png'; // Fallback image
                        }} style={{width: '100%', height: '100%',objectFit: 'cover'}} />
                      </div>
                      <div className='flex-1 ms-2'>
                        <h6 className="mb-0 fw-semibold" style={{ fontSize: '14px' }}>
                          {newItem.title.split(' ').length <= 10
                            ? newItem.title
                            : `${newItem.title.split(' ').slice(0, 10).join(' ')}...`}
                        </h6>
                        <span className='mb-0' style={{fontSize: '10px', color: 'gray'}}>{newItem.date}</span>
                      </div>
                    </div>
                    ))}
                  </div>
                </a>
              </div>
            </a>
            <Link to="/about">About</Link>
            <Link to="/faq">Faq</Link>
            <Link to="/whyus">Why Us</Link>
          </nav>
        </div>
        <div className='d-flex align-items-center'>
          <Link to="/account" state={{location: 'register'}} className='px-4 fw-bold text-white' style={{textDecoration: 'none', fontSize:'14px'}}>SIGN UP</Link>
          <Link to="/account" state={{location: 'login'}} className='btn mybtn2 rounded-3 p-n' style={{fontSize:'14px'}}>LOGIN</Link>
          {!sidebar ? (
            <FontAwesomeIcon icon={faBars} className="ms-3 text-black d-md-none" style={{fontSize: '16px'}} onClick={() => setSidebar(true)} />
          ) :(
            <FontAwesomeIcon icon={faTimes} className="ms-3 text-black d-md-none" style={{fontSize: '16px'}} onClick={() => setSidebar(false)} />
          )
          }
        </div>
      </header>
    </>
  )
}

export default FrontHeader